import React from 'react'
import { useRouter } from 'next/router'
import { useQuery } from 'react-query'

import { useBookCollectionAction } from '@hooks/bookCollection/useBookCollectionAction'
import { BookListTabAcceptProps, BookListTabProps } from './interface'

export function withBookListTab(Component: React.FC<BookListTabProps>) {
  function WithBookListTab({ userId }: BookListTabAcceptProps) {
    const router = useRouter()
    const bookCollectionClient = useBookCollectionAction()

    const { data: bookCollections = [] } = useQuery(
      ['book-collection-by-user', userId],
      () => bookCollectionClient.getBookCollectionByUserId(userId),
      { enabled: !!userId }
    )

    function handleGoToBookCollectionDetail(id: number) {
      router.push(`/collection/${id}`)
    }

    const componentProps = {
      bookCollections,
      handleGoToBookCollectionDetail,
    }
    return <Component {...componentProps} />
  }

  return WithBookListTab
}
